var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNorth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2126 6.58765L8.31257 9.48765C8.12924 9.67098 7.89591 9.76265 7.61257 9.76265C7.32924 9.76265 7.09591 9.67098 6.91257 9.48765C6.72924 9.30431 6.63757 9.07098 6.63757 8.78765C6.63757 8.50431 6.72924 8.27098 6.91257 8.08765L11.5126 3.48765C11.6126 3.38765 11.7209 3.31681 11.8376 3.27515C11.9542 3.23348 12.0792 3.21265 12.2126 3.21265C12.3459 3.21265 12.4709 3.23348 12.5876 3.27515C12.7042 3.31681 12.8126 3.38765 12.9126 3.48765L17.5126 8.08765C17.6959 8.27098 17.7876 8.50431 17.7876 8.78765C17.7876 9.07098 17.6959 9.30431 17.5126 9.48765C17.3292 9.67098 17.0959 9.76265 16.8126 9.76265C16.5292 9.76265 16.2959 9.67098 16.1126 9.48765L13.2126 6.58765L13.2126 19.7876C13.2126 20.071 13.1167 20.3085 12.9251 20.5001C12.7334 20.6918 12.4959 20.7876 12.2126 20.7876C11.9292 20.7876 11.6917 20.6918 11.5001 20.5001C11.3084 20.3085 11.2126 20.071 11.2126 19.7876L11.2126 6.58765Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorth);
export default __webpack_public_path__ + "static/media/North.0f84f21b.svg";
export { ForwardRef as ReactComponent };